import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Subscription } from 'rxjs';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { ConfirmationService, Message, SelectItem } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { PagamentoDespesaService } from 'src/app/admihair/service/pagamento-despesa.service';
import { PagamentoDespesa } from 'src/app/admihair/api/dto/pagamento-despesa';
import { CompetenciaDTO } from 'src/app/admihair/api/dto/competencia-dto';
import { AdmihairBaseComponent } from '../../../admihair-base.component';


@Component({
  selector: 'app-pagamento-despesa-listar',
  templateUrl: './pagamento-despesa-listar.component.html',
  styleUrls: ['./pagamento-despesa-listar.component.scss']
})
export class PagamentoDespesaListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  permissaoPagar: boolean = false;
  permissaoEstornar: boolean = false;
  filtros: SelectItem[] = [
    { label: 'A PAGAR', value: [0,2,3] },
    { label: 'PAGAS', value: [1] },
    { label: 'AGENDADAS', value: [2] },
    { label: 'ESTORNADAS', value: [3] }
  ];
  filtroSelecionado: number[] = [0,3];
  eventBusSub?: Subscription;
  empresaSelecionada?: Empresa;
  pagamentosDespesas: PagamentoDespesa[] = [];
  planosContaEmpresa: PlanoContaEmpresa[] = [];
  loading: boolean = false;
  datas: SelectItem[] = [{ label: 'Vencimento', value: 1 }, { label: 'Pagamento', value: 2 }];
  tipoDataSelecionado: string = 'vencimento';
  dataInicial: Date = new Date();
  dataFinal: Date = new Date();

  filtroMesesPagamentos: SelectItem[] = [];
  filtroMesSelecionado?: CompetenciaDTO;

  constructor(
    private pagamentoDespesaService: PagamentoDespesaService,
    private confirmationService: ConfirmationService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    erroService: ErroService,
    utilStorageService: UtilStorageService,) {
      super(erroService, utilStorageService)
     }



  ngOnInit(): void {
    this.loading = true;
    this.verificarPermissoes();
    this.empresaSelecionada = this.getEmpresa();
    this.dataFinal.setDate(this.dataFinal.getDate() + 60);
    if (this.permissaoListar) {
      this.listarCompetenciasVencimentoPagamento();
    }
  }

  listarCompetenciasVencimentoPagamento() {
    this.pagamentoDespesaService.listarCompetenciasDespesas(this.empresaSelecionada?.id)
      .subscribe({
        next: (data: CompetenciaDTO[]) => {
          this.filtroMesesPagamentos = data.map(comp => (
            {label: comp.descricao, value: comp})
          );
          this.filtroMesSelecionado = data[0];
          this.listarPagamentos();
        },
        error: (err: any) => {
          this.loading = false;
          this.exibirMensagemErro(err);
        }
      })
  }

  recarregarDados() {
    this.loading = true;
    this.listarPagamentos();
  }

  listarPagamentos() {
    this.pagamentoDespesaService
      .listarPorEmpresaECompentenciaVencimentoEStatus(
        this.empresaSelecionada?.id,
        this.filtroMesSelecionado?.mes,
        this.filtroMesSelecionado?.ano,
        this.filtroSelecionado
      )
      .subscribe({
        next: (data: PagamentoDespesa[]) => {
          this.loading = false;
          this.pagamentosDespesas = data;
        },
        error: (err: any) => {
          this.loading = false;
          this.exibirMensagemErro(err);
        }
      });
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  excluirDespesa(id: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {

        this.pagamentoDespesaService.excluir(id).subscribe({
          next: () => {
            this.exibirMensagemSucesso();
            this.listarPagamentos();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
            this.listarPagamentos();
          }
        });
      }
    });
  }

  estornarDespesa(pagamentoSelecionado: PagamentoDespesa) {
    this.confirmationService.confirm({
      message: 'Estornar Pagamento?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.loading = true;
        const pagamentoAtualizado: PagamentoDespesa = pagamentoSelecionado;
        pagamentoAtualizado.dataFluxo = undefined;
        pagamentoAtualizado.operador = this.getUsuarioLogadoSistema().id;
        pagamentoAtualizado.status = 3;
        pagamentoAtualizado.tipoPagamento = undefined;
        console.log(pagamentoAtualizado)

        this.pagamentoDespesaService.atualizar(pagamentoAtualizado, pagamentoAtualizado.id).subscribe({
          next: () => {
            this.exibirMensagemSucesso();
            this.listarPagamentos();
          },
          error: (err: any) => {
            this.loading = false;
            this.exibirMensagemErro(err);
          }
        });
      }
    });
  }

  detalharDespesa(id: number) {
    this._router.navigate(["/apps/pagamento-despesa/detalhar/" + id], { relativeTo: this._activatedRoute })
  }

  pagarDespesa(id: number) {
    this._router.navigate(["/apps/pagamento-despesa/pagar/" + id], { relativeTo: this._activatedRoute })
  }

  verificarPermissoes() {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_PAGAMENTO_DESPESA');
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_PAGAMENTO_DESPESA');
    this.permissaoPagar = this.verificarPermissao('PERM_PAGAR_PAGAMENTO_DESPESA');
    this.permissaoExcluir = this.verificarPermissao('PERM_EXCLUIR_PAGAMENTO_DESPESA');
    this.permissaoEstornar = this.verificarPermissao('PERM_ESTORNAR_PAGAMENTO_DESPESA');
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_PAGAMENTO_DESPESA');
  }

}
